import pick from 'lodash/pick';
import { useEffect } from 'react';

import { ADDRESS_BASE_KEYS } from '~src/constants/address';
import { AddressWithBbrId } from '~src/model';

import { CUSTOMER_ADDRESS, useCachedState } from '../useCachedState';
import { useAddressLookupByID } from './useAddressLookupByID';

export const useOverrideAddressByID = () => {
  const [address, setAddress] = useCachedState<AddressWithBbrId>(CUSTOMER_ADDRESS);
  const addressByID = useAddressLookupByID();

  useEffect(
    function setFoundAddress() {
      if (addressByID) {
        setAddress(pick(addressByID, [...ADDRESS_BASE_KEYS, 'id']));
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addressByID]
  );

  return { address, setAddress, addressID: addressByID?.id };
};
